import {
  UPDATE_CALCULATOR,
  DISPLAY_VARIATIONS,
  UPDATE_COMPONENT_LIST,
  FETCH_LOGISTICS_AMOUNT,
  FETCH_LOGISTICS_AMOUNT_SUCCESS,
  FETCH_LOGISTICS_AMOUNT_ERROR,
  FETCH_DURATIONS,
  FETCH_DURATIONS_SUCCESS,
  FETCH_DURATIONS_ERROR,
  UPDATE_CALCULATOR_PRICE,
  CLEAR_CALCULATOR,
  FETCH_ALL_PROVINCES_SUCCESS,
  FETCH_ALL_PROVINCES_ERROR,
  FETCH_PRODUCT_SUCCESS,
  FETCH_PRODUCTS_SUCCESS
} from "../actions/types";
import { getNetPrice, getTax } from "../utils/helpers";

// Global state of the calculator when initialized
const initialState = {
  total: "0",
  net: "0",
  tax: "0",
  collapsed: true,
  steps: [
    {
      index: 1, // Step number
      name: "", // Name of step
      token: "",
      active: false, // If step is active
      visited: false, // If step has already been visited
      selectedComponent: "", // The option that was selected
      path: "" // The URL to navigate back to
    },
    {
      index: 2,
      name: "Pacchetto",
      active: false,
      visited: false,
      price: "",
      net: "",
      tax: "",
      selectedComponent: "",
      path: ""
    },
    {
      index: 3,
      name: "Componenti",
      active: false,
      visited: false,
      price: "",
      net: "",
      tax: "",
      components: [],
      path: ""
    },
    {
      index: 4,
      name: "Extra",
      active: false,
      visited: false,
      price: "",
      net: "",
      tax: "",
      components: [],
      path: ""
    },
    {
      index: 5,
      name: "Logistica",
      price: "",
      net: "",
      tax: "",
      active: false,
      visited: false,
      selectedComponent: "",
      path: ""
    },
    {
      index: 6,
      name: "Durata",
      active: false,
      visited: false,
      selectedComponent: "",
      path: ""
    }
  ],
  options: [],
  components: [],
  loading: false,
  logisticsAmount: 0,
  durations: [],
  error: false,
  coefficient: 0,
  average: 1,
  products: [],
  currentProduct: {}
};

export default function(state = initialState, action) {
  switch (action.type) {
    case UPDATE_CALCULATOR:
      let toUpdate = action.payload.data; // Data to be updated
      let step = action.payload.step; // Step to update
      let stepsUpdated = [...state.steps]; // Copy of steps array
      // Make active false in all the steps
      stepsUpdated.forEach(step => {
        step.active = false;
      });
      // New updated step, merging the old steps and new data
      let stepToUpdate = { ...stepsUpdated[step - 1], ...toUpdate };
      stepsUpdated[step - 1] = stepToUpdate; // Replacing the old step with the updated step
      // Get the totalPrice

      // let step1price = stepsUpdated[1].price,
      //     step2price = stepsUpdated[2].price,
      //     step3price = stepsUpdated[3].price,
      //     step4price = stepsUpdated[4].price;

      const totalPrice =
        stepsUpdated[1].price * (1 + state.coefficient) +
        stepsUpdated[2].price * (1 + state.coefficient) +
        stepsUpdated[3].price * (1 + state.coefficient) +
        stepsUpdated[4].price;

      let rentAmount =
        stepsUpdated[1].price + stepsUpdated[2].price + stepsUpdated[3].price;
      localStorage.setItem("rentAmount", rentAmount);
      return {
        ...state,
        steps: stepsUpdated,
        total: parseFloat(totalPrice),
        net: getNetPrice(totalPrice),
        tax: getTax(totalPrice)
      };

    case DISPLAY_VARIATIONS:
      // Display the options when edit component is clicked
      let name = action.payload; // Name of the component
      let selectedPackage = state.steps[1].packageDetails; // Get the selected package
      let options = selectedPackage.items.filter(
        item => item.variation === name
      ); // The options are the items that have the same variation name
      return { ...state, options };
    case UPDATE_COMPONENT_LIST:
      const components = action.payload;
      return { ...state, components };
    case FETCH_LOGISTICS_AMOUNT:
      return { ...state, loading: true };
    case FETCH_LOGISTICS_AMOUNT_SUCCESS:
      let { amount } = action.payload.data;
      // let amount = 299;
      return {
        ...state,
        loading: false,
        error: false,
        logisticsAmount: amount
      };
    case FETCH_LOGISTICS_AMOUNT_ERROR:
      return { ...state, loading: false, error: true };
    case FETCH_DURATIONS:
      return { ...state, loading: true };
    case FETCH_DURATIONS_SUCCESS:
      let durations = action.payload.data;
      return { ...state, loading: false, durations };
    case FETCH_DURATIONS_ERROR:
      return { ...state, loading: false, error: true };
    case UPDATE_CALCULATOR_PRICE:
      const { coefficient, average } = action.payload;
      return { ...state, coefficient, average };
    case CLEAR_CALCULATOR:
      return { ...initialState };
    case FETCH_ALL_PROVINCES_SUCCESS:
      let provinces = action.payload.data;
      return { ...state, provinces };
    case FETCH_ALL_PROVINCES_ERROR:
      return { ...state, error: true };
    case FETCH_PRODUCT_SUCCESS:
      let product = action.payload.data;
      return { ...state, currentProduct: product };
    case FETCH_PRODUCTS_SUCCESS:
      let products = action.payload.data;
      return { ...state, products };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_calculator.js